import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        align-items: center;\n        background-color: ", ";\n        border-radius: 3px;\n        box-sizing: border-box;\n        color: ", ";\n        display: flex;\n        margin: ", ";\n        padding: ", ";\n        text-transform: uppercase;\n        width: 100%;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
export var StyledSection = styled.div(_templateObject(), function (props) {
  return css(_templateObject2(), props.theme.components.sideNav.section.background, props.theme.components.sideNav.section.color, props.theme.components.sideNav.section.margin, props.theme.components.sideNav.section.padding);
});